import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import { ErrorWord, yapNumberWhen, yapBoolWhen, EstablishPageType } from '../common';
/*--------------
  指定預金口座情報
  --------------*/
export enum DEPOSIT_TYPE {
  NORMAL = 1,
  SAVING,
}

export const getDepositType = (type: number | null) => {
  switch (type) {
    case DEPOSIT_TYPE.NORMAL:
      return true;
    case DEPOSIT_TYPE.SAVING:
      return false;
    default:
      return undefined;
  }
};

//入力値の型
export type DepositAccountType = {
  // ゆうちょ銀行かどうか（これはリクエストに不要）
  // リクエスト時にゆうちょかどうかで採用するパラメータ切り替える
  isYuchoBank: boolean;
  // 銀行コード
  bankCode: string;
  // 金融機関名
  bankName: string; //（これはリクエストに不要）
  // 店番号
  branchCode: string;
  // 支店名
  branchName: string; //（これはリクエストに不要）
  // 銀行口座番号
  accountNumber: string;
  // 預金種目
  depositForm: number;
  // 銀行コード
  bankCodeOfYucho: string; //（これはリクエストに不要）
  // 金融機関名
  bankNameOfYucho: string; //（これはリクエストに不要）
  // 店番号
  branchCodeOfYucho: string; //（これはリクエストに不要）
  // 支店名
  branchNameOfYucho: string; //（これはリクエストに不要）
  // 銀行口座番号
  accountNumberOfYucho: string; //（これはリクエストに不要）
  // 預金種目
  depositFormOfYucho: number; //（これはリクエストに不要）
};
//Formik用の型
export type DepositAccountFormikType = FormikProps<DepositAccountType>;

//Formikに渡す初期値
export const depositAccountInfoInitialValues = (param: DepositAccountType) => {
  return {
    ...param,
    isYuchoBank: param.isYuchoBank ?? null,
    bankCode: param.bankCode || '',
    bankName: param.bankName || '',
    branchCode: param.branchCode || '',
    branchName: param.branchName || '',
    accountNumber: param.accountNumber || '',
    depositForm: param.depositForm ?? null,
    bankCodeOfYucho: param.bankCodeOfYucho || '',
    bankNameOfYucho: param.bankNameOfYucho || '',
    branchCodeOfYucho: param.branchCodeOfYucho || '',
    branchNameOfYucho: param.branchNameOfYucho || '',
    accountNumberOfYucho: param.accountNumberOfYucho || '',
    depositFormOfYucho: param.depositFormOfYucho ?? null,
  };
};

//バリデーション
export const depositAccountInfoValidation = Yup.object().shape({
  isYuchoBank: Yup.bool().nonNullable(ErrorWord.SELECT),
  bankCodeOfYucho: yapNumberWhen('isYuchoBank', true, ErrorWord.INPUT_HALF_NUMBER, 4),
  branchCodeOfYucho: yapNumberWhen('isYuchoBank', true, ErrorWord.INPUT_HALF_NUMBER, 3),
  accountNumberOfYucho: yapNumberWhen('isYuchoBank', true, ErrorWord.INPUT_HALF_NUMBER, 7),
  depositFormOfYucho: yapNumberWhen('isYuchoBank', true, ErrorWord.SELECT),
  bankCode: yapNumberWhen('isYuchoBank', false, ErrorWord.INPUT_HALF_NUMBER, 4),
  branchCode: yapNumberWhen('isYuchoBank', false, ErrorWord.INPUT_HALF_NUMBER, 3),
  accountNumber: yapNumberWhen(
    'isYuchoBank',
    false,
    ErrorWord.INPUT_HALF_NUMBER +
      '。口座番号が7桁未満の場合は、口座番号の前に「0（ゼロ」「00」等を入力し、7桁になるようにしてください。',
    7,
  ),
  depositForm: yapNumberWhen('isYuchoBank', false, ErrorWord.SELECT),
});

//Formikのサブミットメソッド
export const depositAccountInfoOnSubmit = <T>(param: T, add: (data: T) => void, cb?: () => void) => {
  return (values: DepositAccountType) => {
    add({
      ...param,
      isYuchoBank: values.isYuchoBank,
      bankCode: values.bankCode,
      bankName: values.bankName,
      branchCode: values.branchCode,
      branchName: values.branchName,
      accountNumber: values.accountNumber,
      depositForm: values.depositForm,
      bankCodeOfYucho: values.bankCodeOfYucho,
      bankNameOfYucho: values.bankNameOfYucho,
      branchCodeOfYucho: values.branchCodeOfYucho,
      branchNameOfYucho: values.branchNameOfYucho,
      accountNumberOfYucho: values.accountNumberOfYucho,
      depositFormOfYucho: values.depositFormOfYucho,
    });
    cb && cb();
  };
};
